// Initiates Zendesk chat widget on Interaction
// --------------------------------------------------

import scriptLoader from "../utilities/scriptLoader";
const facadeBtn = document.querySelector("#zendesk-facade-btn");
const facadeLoader = document.querySelector("#zendesk-facade-loading");


facadeBtn.addEventListener("click", () => {
    facadeBtn.classList.add("hidden");
    facadeLoader.classList.remove("hidden");
    
    const loader = new scriptLoader('ze-snippet');

    loader
        .load(["//static.zdassets.com/ekr/snippet.js?key=996e9153-558e-4df4-90f9-c18979b80516"])
        .then(() => {
            console.log(`zendesk chat loaded!`);
        });
}, { once: true });
